import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import SettingsPage from '@/settings/pages';

export const Route = createFileRoute('/settings/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: SettingsRoute,
  staticData: {
    headerSection: null
  }
});

function SettingsRoute() {
  return <SettingsPage/>;
}
